import { canCallApp, config } from '../utils';
import * as Ajax from '../utils/ajax.js';
import  { EventBusSingleton }  from '../utils/event-bus-singleton';
import { getCookie, setCookie } from '../utils/cookies';
import * as BI from '../tracking/bi.js';
import * as $ from 'jquery';

// Data models tracking (BI & Zendesk)
import { BuySizePersonalizeBIModel } from '../BI/models';
import {dataLayerEvent} from '../tracking/data-layer.js';
import { onLoad } from '../utils/onLoad.js';
const eventBus = EventBusSingleton.getInstance();

require('../../css/dsv1/_personalize-sizes.scss');

let biFlow;
if ( config.section === 'home' ) {
    biFlow = 'feed';
}
if ( config.section === 'filters' ) {
    biFlow = 'search';
}
const BI_ACTION_CLOSED = "closed";
const BI_ACTION_SAVED = "saved";

const UI = {
    component: 'personalize-sizes',
    componentWarning: '.personalize-sizes-warning',
    button: '.slide-arrow-next',
    checkbox: 'input[name^="sizes"]',
    checkboxTop: 'input[name="sizes[alta][]"]',
    checkboxBottom: 'input[name="sizes[baja][]"]',
    checkboxShoes: 'input[name="sizes[zapatos][]"]',
    slideToAnimate: '.personalize-sizes-slide',
    section: '[data-section]',
    closeDrawer: '.js-personalize-sizes-close'
};

const LAST_SECTION = 'shoes';
const DISABLED = 'disabled';
const DISABLED_BUTTON_TITLE ='Selecciona una talla';
const ENABLED_BUTTON_TITLE ='Ir a siguiente talla';

const buttons = document.querySelectorAll(UI.button);
const component = document.getElementById(UI.component);
const slideToAnimate = document.querySelector(UI.slideToAnimate);
const componentWarning = document.querySelector(UI.componentWarning);

const _addEventInButtons = () => {
    buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            const currentSection = e.target.closest(UI.section)?.dataset.section;
            const orderBtn = e.target?.dataset.order;

            if (!e.target?.classList.contains('disabled')) {
                if (currentSection !== LAST_SECTION) {
                    slideToAnimate.style.marginLeft = `-${orderBtn * 100}%`;
                }
                else {
                    const formData = new FormData(component);
                    Ajax.post(component.getAttribute('action'), formData).then((response) => {
                        if (response.error === 0) {
                            const buySizePersonalizeBIModel = new BuySizePersonalizeBIModel(config.user.id, biFlow, BI_ACTION_SAVED);
                            dataLayerEvent('saved_sizes');
                            BI.track(buySizePersonalizeBIModel);
                            if (canCallApp("refreshUser")) Trendier.refreshUser();
                            location.reload();
                        }
                    });
                }
            }
        });
    });
}

const _addEventInCheckboxes = () => {
    const allCheckboxes = document.querySelectorAll(UI.checkbox);
    allCheckboxes.forEach((btn) => {
        btn.addEventListener('change', (e) => {
            const currentSection = e.target?.closest(UI.section)?.dataset.section;
            const buttonNext = document.querySelector(`[data-section="${currentSection}"] .slide-arrow-next`);

            if (_atLeastOneCheckbox(UI[`checkbox${currentSection?.charAt(0).toUpperCase() + currentSection?.slice(1)}`])) {
                buttonNext?.classList.remove(DISABLED);
                if (currentSection !== LAST_SECTION) {
                    buttonNext && (buttonNext.title = ENABLED_BUTTON_TITLE);
                }
            } else {
                buttonNext?.classList.add(DISABLED);
                buttonNext && (buttonNext.title = DISABLED_BUTTON_TITLE);
            }
        });
    });
}

const _handleDrawer = (data, id) => {
    if (id === UI.component) {
        const closePersonalizeSizes = document.querySelector(UI.closeDrawer);
        closePersonalizeSizes.addEventListener('click', () => {
            // Cookie max-age in seconds -> 7 days (24 * 3600 * 7)
            const inSevenDays = 24 * 3600 * 7;
            component.classList.add('d-none');
            setCookie('reminder-personalize-sizes', true, inSevenDays );
            const buySizePersonalizeBIModel = new BuySizePersonalizeBIModel(config.user.id, biFlow, BI_ACTION_CLOSED);
            BI.track(buySizePersonalizeBIModel);
        })
    }
}

const _subscribeDrawer = () => {
    eventBus.subscribe("createAndShowDrawer", (data, id) => {
        _handleDrawer(data, id);
    });
}

const _atLeastOneCheckbox = (element) => {
    const checkboxes = document.querySelectorAll(element);
    return [...checkboxes].some((checkbox) => checkbox.checked);
};

const _showReminder = () => {
    componentWarning?.classList.remove('d-none'); 
    setCookie('visited-personalize-sizes', true, 24 * 3600 * 365 * 20);
}

const _setClosingCollapse = () => {
    const collapse = document.querySelector( '#personalizeSizesGrid' );
    if ( collapse ) {
        $( collapse ).on( 'show.bs.collapse', () => {
            const collapseBtn = document.querySelector( `a[href="#${ collapse.id }"]` );
            if ( collapseBtn && collapseBtn.querySelector( '.icon-chevron-down' ) ) {
                collapseBtn.removeAttribute( 'data-toggle' );
                collapseBtn.removeAttribute( 'href' );
                collapseBtn.style.pointerEvents = 'none';
                const icon = collapseBtn.querySelector( '.icon-chevron-down' );
                icon.classList.remove( 'icon-chevron-down' );
                icon.classList.add( 'icon-close' );
                icon.style.pointerEvents = 'auto';
                icon.addEventListener( 'click', () => {
                    collapseBtn.parentElement.remove();
                    setCookie( 'reminder-personalize-sizes', true, 24 * 3600 * 7 );
                    const buySizePersonalizeBIModel = new BuySizePersonalizeBIModel(config.user.id, 'search', BI_ACTION_CLOSED);
                    BI.track(buySizePersonalizeBIModel);
                } );
            }
        } );
    }
}

const _removeBanner = () => {
    const collapse = document.querySelector( '#personalizeSizesGrid' );
    collapse?.parentElement.remove();
}

const _setDeleteSizes = () => {
    const deleteBtnSizes = document.querySelector('.js-remove-all-sizes');
    if (deleteBtnSizes) {
        deleteBtnSizes.addEventListener('click', e => {
            e.preventDefault();
            deleteBtnSizes.toggleAttribute('disabled', true);
            Ajax.post('/profile/create_sizes', {'delete-user-sizes':1}).then((response) => {
                if (response.error === 0) {
                    dataLayerEvent('saved_sizes');
                    if (canCallApp("refreshUser")) {
                        Trendier.refreshUser();
                    }
                    location.reload();
                }
            });
        });
    }
};

const initPersonalizeSizes = () => {

    const reminder = getCookie('reminder-personalize-sizes');
    if (reminder === "true" && config.section !== 'profile') {
        _showReminder();
        _removeBanner();
    } else {
        _addEventInButtons();
        _addEventInCheckboxes();
        _subscribeDrawer();
        _setClosingCollapse();
        _setDeleteSizes();
    }
}
onLoad(() => { //Cerrar el banner cuando no hay drawer
    const closeBtn = document.querySelector('[data-toggle="drawer"][data-target="#personalize-sizes"]');
    const banner = closeBtn?.closest('.personalize-sizes');
    if (banner) {
        closeBtn.addEventListener('click', e => {
            e.preventDefault();
            setCookie( 'reminder-personalize-sizes', true, 24 * 3600 * 7 );
            banner.remove()
        });
    }
});

export default {
    init: initPersonalizeSizes
}